export function getHostUrl() {
  if (process.env.NODE_ENV != 'production') {
    console.log('is not production');
    return 'http://localhost:8090/integration';
  } else {
    return 'http://189.003.190.29:8051/integration';
  }
}
;